// extracted by mini-css-extract-plugin
export default {"list":"List-module__list__WwXy1","direction":"List-module__direction__lQ7Fg","direction-column":"List-module__direction-column__PJtfX"};